export default "__VITE_ASSET__DM1_lx$w__"